module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-500.ec50f3eeafa036818c72.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.woff
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.woff
// module chunks = styles